  // src/services/AuthService.jsx
  import axios from "axios";
  import BASE_URL from "./baseURL";

  export const loginUser = async (email, password) => {
    try {
      const response = await axios.post(`${BASE_URL}/trainee/login`, { email, password });
      // Axios throws for non-2xx responses, so we can assume success and return data.
      return response.data;
    } catch (error) {
      console.error("Error during login:", error);
      // Re-throw for the caller to handle.
      throw error;
    }
  };

export const getTraineeProfile = async (traineeToken) => {
  try {
    const response = await axios.post(`${BASE_URL}/trainee/getTraineeProfile`, { 
      TraineeToken: traineeToken 
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching trainee profile:", error);
    throw error;
  }
};